import { PageMetaData } from '../types';

export const pageMetaDataInfo: PageMetaData[] = [
    {
        path: '/',
        title: 'Home',
        description: 'Welcome to Arla Foods Developer Portal',
    },
    {
        path: '/catalog',
        title: 'Arla Foods AMBA Catalog',
        description: 'Explore your organization\'s software catalog',
    },
    {
        path: '/docs',
        title: 'Arla Foods AMBA Documentation',
        description: 'Documentation available in Arla Foods AMBA',
    },
    {
        path: '/api-docs',
        title: 'Arla Foods AMBA APIs',
        description: 'Arla Foods AMBA API Explorer',
    },
    {
        path: '/search',
        title: 'Arla Foods AMBA Search',
        description: 'Search across your software catalog',
    },
    {
        path: '/product-teams',
        title: 'Arla Foods AMBA Product Teams',
        description: '',
    },
    {
        path: '/create',
        title: 'Arla Foods AMBA Create',
        description: 'Create new components from templates',
    },
    {
        path: '/settings',
        title: 'Arla Foods AMBA Settings',
        description: 'Manage your profile and preferences',
    },
    {
        path: '/catalog-import',
        title: 'Register an existing component',
        description: 'Import entities into the catalog from a YAML file',
    },
];

export const getPageMetaData = (path: string): PageMetaData | null => {
    const pageInfo = pageMetaDataInfo.find(info => info.path === path);
    return pageInfo || null;
}
